module.exports = __webpack_public_path__ + "static/media/empresa.04db5bd9.jpg";